import { usePaginatedApi } from "../../../swr/useApi";

import { productService } from "../../api_client";
import type {
    ProductDto,
    ProductsQueryDto,
} from "../../../api";

export function useMyProducts(query?: ProductsQueryDto) {
    return usePaginatedApi<ProductDto, ProductsQueryDto>({
        key: "my-products",
        serviceMethod: async (queryParams) => await productService.getMyProducts(queryParams),
        query: query,
    });
}

